<div class="classification-table-header" (click)="$event.stopPropagation()">
	<span class="selected-classification" [matMenuTriggerFor]="profileMenu"
		>{{ 'classification' | translate }}: {{ givenName() | translate }}</span
	>
	<span>
		<mat-icon [matMenuTriggerFor]="profileMenu" class="accent-icon icon-clickable"
			>arrow_drop_down</mat-icon
		>
	</span>
</div>
<mat-menu #profileMenu="matMenu" class="profile-actions" xPosition="before">
	<!--	enable when  TFM will be supported-->
	<!--	<button (click)="classificationTypeSelected('TFM')" mat-menu-item>-->
	<!--		TFM-->
	<!--	</button>-->

	<button
		(click)="$event.stopPropagation(); classificationTypeSelected('BCT')"
		mat-menu-item
	>
		{{ 'classification_types_bct' | translate }}
	</button>
	<button
		(click)="$event.stopPropagation(); classificationTypeSelected('CCB')"
		mat-menu-item
	>
		{{ 'classification_types_ccb' | translate }}
	</button>
</mat-menu>
